var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlaCiXGj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H5V19L19 18.996V15M16 7L18 9M18.4733 5.32434L19.6757 6.52669C20.1081 6.95914 20.1081 7.66027 19.6757 8.09272L14.1076 13.6608C13.9196 13.8488 13.6661 13.9568 13.4002 13.9622L11.5253 13.9999C11.2328 14.0058 10.9942 13.7672 11.0001 13.4747L11.0378 11.5998C11.0432 11.3339 11.1512 11.0804 11.3392 10.8924L16.9073 5.32434C17.3397 4.89189 18.0409 4.89189 18.4733 5.32434Z",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlaCiXGj);
export default __webpack_public_path__ + "static/media/ILACiXGj.96d3ebb6522c4c7c63cc3424b1e94323.svg";
export { ForwardRef as ReactComponent };